define('glu/grid/sectionLayout',['require','./genericLayout','hbs!./sectionLayout.hbs'],function(require) {
    'use strict';

    var GenericLayout = require('./genericLayout'),
        tpl = require('hbs!./sectionLayout.hbs');

    return GenericLayout.extend({
        template: tpl,
        tagName: 'section',
        initialize: function() {
            GenericLayout.prototype.initialize.apply(this, arguments);
        }
    });
});

